



import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
   apiKey: "AIzaSyAXN63gysGZmtL_4U9UAKA6C9g7yZCqGQk",
  authDomain: "tsk-realtors.firebaseapp.com",
  projectId: "tsk-realtors",
  storageBucket: "tsk-realtors.firebasestorage.app",
  messagingSenderId: "677545217094",
  appId: "1:677545217094:web:2ff0ec8ebe81433588ce47",
  measurementId: "G-1TB3CPE4H7"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;



